module.exports = {
	"ha": "fha",
	"id": 5.7,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by HSDA, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -140,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.76470588235294,
						"dataLabels": {
							"enabled": true,
							"format": "329"
						}
					},
					{
						"y": 90.58823529411765,
						"dataLabels": {
							"enabled": true,
							"format": "308"
						}
					},
					{
						"y": 87.3529411764706,
						"dataLabels": {
							"enabled": true,
							"format": "297"
						}
					},
					{
						"y": 80.88235294117648,
						"dataLabels": {
							"enabled": true,
							"format": "275"
						}
					},
					{
						"y": 59.705882352941174,
						"dataLabels": {
							"enabled": true,
							"format": "203"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.40663900414937,
						"dataLabels": {
							"enabled": true,
							"format": "939"
						}
					},
					{
						"y": 91.80497925311202,
						"dataLabels": {
							"enabled": true,
							"format": "885"
						}
					},
					{
						"y": 89.52282157676349,
						"dataLabels": {
							"enabled": true,
							"format": "863"
						}
					},
					{
						"y": 83.40248962655602,
						"dataLabels": {
							"enabled": true,
							"format": "804"
						}
					},
					{
						"y": 66.49377593360995,
						"dataLabels": {
							"enabled": true,
							"format": "641"
						}
					},
					{
						"y": null
					},
					{
						"y": 98.39449541284404,
						"dataLabels": {
							"enabled": true,
							"format": "858"
						}
					},
					{
						"y": 96.78899082568807,
						"dataLabels": {
							"enabled": true,
							"format": "844"
						}
					},
					{
						"y": 93.34862385321101,
						"dataLabels": {
							"enabled": true,
							"format": "814"
						}
					},
					{
						"y": 86.35321100917432,
						"dataLabels": {
							"enabled": true,
							"format": "753"
						}
					},
					{
						"y": 65.13761467889908,
						"dataLabels": {
							"enabled": true,
							"format": "568"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.2352941176470584,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.382978723404253,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.4074074074074066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.181818181818183,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.5933609958506243,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.750798722044726,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.485875706214691,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.836616454229427,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.273631840796025,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.6055045871559592,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.631701631701632,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.5545023696682443,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.493857493857492,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.568393094289508,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Fraser East<br>n=340"
			},
			{
				"x": 9,
				"text": "Fraser North<br>n=964"
			},
			{
				"x": 15,
				"text": "Fraser South<br>n=872"
			}
		],
		"dataTable": {
			"Fraser East": [
				340,
				329,
				308,
				297,
				275,
				203
			],
			"Fraser North": [
				964,
				939,
				885,
				863,
				804,
				641
			],
			"Fraser South": [
				872,
				858,
				844,
				814,
				753,
				568
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_7.json
// module id = 206
// module chunks = 0